import { ReactElement } from 'react'

interface PageSectionProps {
  title: string
  children: ReactElement
  height: string
}

const PageSection = (props: PageSectionProps) => {
  const { title, children, height } = props
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100px',
          fontSize: '2em',
          fontFamily: 'monospace',
          color: '#fff',
          marginTop: '10px',
        }}
      >
        {title}
      </div>
      <div
        style={{
          width: '100%',
          maxWidth: '1300px',
          height: height,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '24px',
          backgroundColor: '#444',
          padding: '25px',
        }}
      >
        {children}
      </div>
    </>
  )
}

export default PageSection
